import type { EditorPerformanceResult } from '@carboncopyco/types';

export const performanceResultsDefault: EditorPerformanceResult = {
  nodes: {
    total: 0,
    div: 0,
    span: 0,
    button: 0,
    link: 0,
    image: 0,
    h: 0,
    p: 0,
    input: 0,
    iframe: 0,
  },
  searchAndReplace: {
    total: 0,
    text: 0,
    byAttribute: 0,
    input: 0,
    recursiveOnShadowRoot: 0,
    entireDoc: 0,
  },
  rules: {
    image: 0,
    input: 0,
    text: 0,
    link: 0,
    list: 0,
    lock: 0,
    visibility: 0,
    style: 0,
    delete: 0,
    unlock: 0,
    chart: 0,
    total: 0,
  },
  modifications: {
    block_interactions: 0,
    replace_link: 0,
    tooltip: 0,
    total: 0,
  },
  mutations: {
    total: 0,
    callbackCalled: 0,
    callbackTime: 0,
  },
  cache: {
    condenseWhiteSpace: 0,
    condenseWhiteSpaceClear: 0,
    textContentSelectorResolver: 0,
    textContentSelectorResolverClear: 0,
  },
};
